import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-duration-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      @if (state() === 'void') {
        --
      }
      @if (state() === 'time') {
        {{ duration() }}
      }
      @if (state() === 'active') {
        <span class="font-semibold text-error">
          {{ t('ALARMS.ACTIVE') }}
        </span>
      }
    </ng-container>
  `,
})
export class DurationIndicatorComponent {
  dateInit = input.required<Date>();
  dateEnd = input.required<Date>();

  now = signal<Date>(new Date());

  duration = computed(() => {
    const initTime = new Date(this.dateInit()).getTime();
    const endTime = new Date(this.dateEnd()).getTime();

    if (initTime && endTime && initTime < endTime) {
      const durationMs = endTime - initTime;
      return this.formatDuration(durationMs);
    }
    return '0s';
  });

  state = computed<'time' | 'void' | 'active'>(() => {
    const initTime = new Date(this.dateInit())?.getTime();
    const endTime = new Date(this.dateEnd())?.getTime();

    if (!initTime && !endTime) return 'void';
    if (!endTime && initTime) return 'active';
    return endTime > initTime ? 'time' : 'void';
  });

  formatDuration(ms: number): string {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
    const days = Math.floor(ms / (1000 * 60 * 60 * 24));

    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

    return parts.join(' ');
  }
}
